import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const MealDistributionEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.mealDistribution),
        mealName: Type.Optional(Type.String())
    })
]));
